import useAuthority from "../hooks/useAuthority";
import { AUTHORITY_TYPE, MODULES } from "../const";
import { useMediaQuery } from "react-responsive";
import { getInitials } from "../helper";

const Tab = ({
  Icon,
  onClick,
  active,
  errors = false,
  authenticated = false,
  label,
  module = MODULES.Master,
  form = "",
  showMandatory,
  isMandatory,
  resizeForSmallerScreens = false,
  show = true,
}) => {
  const smallScreen = useMediaQuery({ query: "(max-width: 1280px)" });

  const { view } = useAuthority({
    type: AUTHORITY_TYPE.FORM,
    module,
    form,
    editMode: false,
    authenticated: authenticated,
  });

  return (
    <div
      style={!view || !show ? { display: "none" } : {}}
      className={`item ${active ? "active" : ""}`}
      onClick={onClick}
    >
      {Icon && (
        <span
          style={
            showMandatory
              ? {
                  borderRadius: "50%",
                  padding: "5px",
                  backgroundColor: `${errors ? "#e0b4b4" : isMandatory ? "#B4e0b4" : ""}`,
                }
              : {}
          }
        >
          <Icon
            size={15}
            style={
              isMandatory
                ? {}
                : {
                    color: `${errors ? "#9f3a38" : ""}`,
                  }
            }
          />
        </span>
      )}

      <label
        style={{
          marginLeft: "5px",
          color: `${errors ? "#9f3a38" : ""}`,
        }}
      >
        {resizeForSmallerScreens
          ? !smallScreen || active
            ? label
            : getInitials(label)
          : label}
      </label>
    </div>
  );
};

export default Tab;
